import SectionCard from "@/components/SectionCard";
import DonutChart from "@/components/charts/DonutChart";

export default function PanelDistribucion({ stages, applyFilters }) {
  const conVolumen = stages.filter((s) => s.volumen != null);

  return (
    <SectionCard
      title="Distribución por etapa"
      subtitle="Volumen de pacientes por macro-etapa"
      testid="panel-distribucion"
    >
      <DonutChart
        labels={conVolumen.map((s) => s.nombre)}
        series={conVolumen.map((s) => applyFilters(s.volumen))}
        colors={conVolumen.map((s) => s.color)}
        height={280}
      />
    </SectionCard>
  );
}
